export const FINGERPRINT_SCRIPT_ID = "cybersource-fp";
export const FINGERPRINT_NOSCRIPT_ID = "cybersource-fp-ns";

const DEFAULT_COLLECTOR_HOST = "https://h.online-metrix.net";
const SESSION_STORAGE_PREFIX = "cybersource_fp_";

function uuidv4() {
	const cryptoObj = typeof window !== "undefined" ? window.crypto : undefined;

	if (cryptoObj && typeof cryptoObj.randomUUID === "function") {
		return cryptoObj.randomUUID();
	}

	if (cryptoObj && typeof cryptoObj.getRandomValues === "function") {
		const bytes = cryptoObj.getRandomValues(new Uint8Array(16));
		bytes[6] = (bytes[6] & 0x0f) | 0x40;
		bytes[8] = (bytes[8] & 0x3f) | 0x80;
		const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
		return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
	}

	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
		const r = (Math.random() * 16) | 0;
		const v = c === "x" ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}

export function getOrCreateProviderIdentifier(orderCode) {
	const key = `${SESSION_STORAGE_PREFIX}${orderCode}`;
	const existing = sessionStorage.getItem(key);
	if (existing) return existing;

	const providerIdentifier = uuidv4();
	sessionStorage.setItem(key, providerIdentifier);
	return providerIdentifier;
}

export function buildSessionId(prefixToken, providerIdentifier) {
	return `${prefixToken ?? ""}${providerIdentifier}`;
}

function normalizeCollectorHost(fingerprintServer) {
	if (!fingerprintServer) return DEFAULT_COLLECTOR_HOST;

	const withProtocol = /^https?:\/\//i.test(fingerprintServer)
		? fingerprintServer
		: `https://${fingerprintServer}`;

	return withProtocol.replace(/\/+$/, "");
}

export function injectFingerprint({ orgId, prefixToken, fingerprintServer, providerIdentifier }) {
	const host = normalizeCollectorHost(fingerprintServer);
	const sessionId = buildSessionId(prefixToken, providerIdentifier);
	const query = `org_id=${encodeURIComponent(orgId)}&session_id=${encodeURIComponent(sessionId)}`;

	removeFingerprint();

	const script = document.createElement("script");
	script.id = FINGERPRINT_SCRIPT_ID;
	script.type = "text/javascript";
	script.src = `${host}/fp/tags.js?${query}`;
	document.head.appendChild(script);

	const noscript = document.createElement("noscript");
	noscript.id = FINGERPRINT_NOSCRIPT_ID;
	noscript.innerHTML =
		`<iframe style="width: 100px; height: 100px; border: 0; position: absolute; top: -5000px;" ` +
		`src="${host}/fp/tags?${query}"></iframe>`;
	document.body.appendChild(noscript);

	return removeFingerprint;
}

export function removeFingerprint() {
	[FINGERPRINT_SCRIPT_ID, FINGERPRINT_NOSCRIPT_ID].forEach((id) => {
		const node = document.getElementById(id);
		if (node) node.parentNode.removeChild(node);
	});
}
